import { useApi } from '@axiom/ui';
import { Statistics } from '@axiom/const';

import type { TalentSearchActiveQueryFilters } from '../schema/talent-search-active-query-filters';
import { TalentSearchFilterUtil } from '../utils/talent-search-filter-util';
import { CandidateApi } from '../api/candidate-api';

export const useTalentSearchCandidateStatsData = ({
  activeFilters,
}: {
  activeFilters: TalentSearchActiveQueryFilters;
}) => {
  const { newUsedFilters, hasFilters } =
    TalentSearchFilterUtil.getCandidateStatsFilters(activeFilters);
  const filters = {
    stats: [
      {
        id: 'endOfTalentCount',
        type: Statistics.indexes.optedOutCount,
        filters: {
          ...newUsedFilters,
          search: undefined,
          view: undefined,
          sort: undefined,
        },
      },
    ],
  };
  const [response] = useApi(
    hasFilters ? CandidateApi.readCandidateStats(filters) : undefined
  );
  const mutated = response?.data.reduce((acc, item) => {
    acc = {
      ...acc,
      [item.id]: item.count,
    };
    return acc;
  }, {});
  if (hasFilters) {
    return {
      ...mutated,
    };
  }

  return { endOfTalentCount: 0 };
};
